import { render, staticRenderFns } from "./subProcesses.vue?vue&type=template&id=4435e739&scoped=true"
import script from "./subProcesses.vue?vue&type=script&lang=js"
export * from "./subProcesses.vue?vue&type=script&lang=js"
import style0 from "./subProcesses.vue?vue&type=style&index=0&id=4435e739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435e739",
  null
  
)

export default component.exports